import React from 'react';
import { bool, string } from 'prop-types';
import styled, { css } from 'styled-components';
import { media, size } from 'components/styles';

// COMPONENTS
import PlayController from './PlayController';
import VolumeController from './VolumeController';
import PlayerSeekController from './PlayerSeekController';
import SettingsController from './settings_controller/SettingsController';
import PlayerSeriresControllers from './PlayerSeriresControllers';
import PlayerTimer from './PlayerTimer';
import ShakaSlider from 'components/views/vod/components/PlayerWrapper/components/ShakaSlider';
import { useMediaQuery } from 'react-responsive';

const Wrapper = styled.div`
	height: auto;
	width: 100%;
	position: absolute;
	bottom: 0;
	z-index: 999;
	display: flex;
	flex-direction: column;
	opacity: ${({ isFocus }) => (isFocus ? 1 : 0)};
	visibility: ${({ isFocus }) => (isFocus ? 'visible' : 'hidden')};
	transition: opacity 0.3s ease-in-out;
	${media.min.xmin(css`
		height: 16rem;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	`)}
`;

const Container = styled.div`
	display: grid;
	align-items: center;
	justify-items: center;

	${({ right }) =>
		right
			? css`
					right: 0;
					padding: 0 4rem 0 0;
					grid-template-columns: 8rem 4rem 4rem;
					grid-gap: 1rem;
			  `
			: css`
					left: 0;
					padding: 0 0 0 4rem;
					grid-template-columns: 4rem 4rem 4rem;
					grid-gap: 2rem;
			  `}
`;

const Row = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	padding: 0.5rem 2rem;
`;

export const PlayerControllers = React.memo(
	({ isFocus, isEpisode, isEpisodeAvaiable, ...restProps }) => {
		const isMobile = useMediaQuery({ query: `(max-width: ${size.xsmall}px)` });
		if (isMobile) {
			return (
				<Wrapper isFocus={isFocus}>
					<Row>
						<PlayController />
						{!isEpisode ? (
							<PlayerSeekController />
						) : (
							<PlayerSeriresControllers isEpisodeAvaiable={isEpisodeAvaiable} />
						)}
						<VolumeController />
						<SettingsController />
					</Row>
					<Row>
						<ShakaSlider {...restProps} />
						<PlayerTimer />
					</Row>
				</Wrapper>
			);
		}
		return (
			<Wrapper isFocus={isFocus}>
				<Container>
					<PlayController />
					{!isEpisode ? (
						<PlayerSeekController />
					) : (
						<PlayerSeriresControllers isEpisodeAvaiable={isEpisodeAvaiable} />
					)}
				</Container>

				<ShakaSlider {...restProps} />

				<Container right>
					<PlayerTimer />
					<VolumeController />
					<SettingsController />
				</Container>
			</Wrapper>
		);
	},
	(prev, next) => JSON.stringify(prev) === JSON.stringify(next)
);

PlayerControllers.propTypes = {
	isFocus: bool.isRequired,
	isEpisode: bool.isRequired,
	isEpisodeAvaiable: bool.isRequired,
	isPreviewAvailable: bool,
	type: string.isRequired
};

export default PlayerControllers;
